import { ComponentParams } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';
import styles from './BioListing.module.scss';
import ConditionalWrapper from 'components/helpers/ConditionalWrapper/ConditionalWrapper';
import { useI18n } from 'next-localization';

const cx = classNames.bind(styles);

export type BioItem = {
  id: string;
  name: string;
  title: string[];
  email: string;
  tty: string;
  phone: string;
  image: string;
  url: string;
  supportedGeographicAreas: GeographicArea[];
};

type GeographicArea = {
  id: string;
  value: string;
};

type BioListingItemProps = {
  item: BioItem;
  params: ComponentParams;
  fallbackImage: string;
};

const BioListingItem = ({ item, params, fallbackImage }: BioListingItemProps): JSX.Element => {
  const sendEmailRef = item.email ? `mailto:${item.email}` : '';
  const showTitle = params.showTitle === '1';
  const showEmailAddress = params.showEmailAddress === '1';
  const showPhoto = params.showPhoto === '1';
  const showTTY = params.showTTY === '1';
  const showPhoneNumber = params.showPhoneNumber === '1';
  const bioImageUrl = item.image ? item.image : fallbackImage;

  const { t } = useI18n();

  return (
    <div className={cx('bio-listing-item')} attr-data-type="bio-item">
      {showPhoto && bioImageUrl && (
        <div className={cx('bio-listing-item-photo')}>
          <ConditionalWrapper condition={item.url} wrapper={(children) => <a href={item.url}>{children}</a>}>
            <>
              <img src={bioImageUrl} alt={item.name} className="img-fluid" loading="lazy" />
            </>
          </ConditionalWrapper>
        </div>
      )}
      <div className={cx('bio-listing-item-info')}>
        <ConditionalWrapper condition={item.url} wrapper={(children) => <a href={item.url}>{children}</a>}>
          {<h3 className={cx('mb-2', 'mt-1', 'bio-listing-title')}>{item.name}</h3>}
        </ConditionalWrapper>
        {item?.title?.length > 0 && showTitle && item?.title?.map((title, index) => <h4 key={index}>{title}</h4>)}
        {item?.phone && showPhoneNumber && (
          <p>
            {item.phone}
            {item?.tty && showTTY && (
              <span className={cx('tty')}>
                {t('BioDetailTTYLabel')}: {item.tty}
              </span>
            )}
          </p>
        )}
        {item?.email && showEmailAddress && <a href={sendEmailRef}>{item.email}</a>}
      </div>
    </div>
  );
};

export default BioListingItem;
